import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ChatBot from './components/ChatBot';
import LeadPopup from './components/LeadPopup';
import StickyContactBar from './components/StickyContactBar';

// Pages
import Home from './pages/Home';
import Puppies from './pages/Puppies';
import Supplies from './pages/Supplies';
import Care from './pages/Care';
import Reviews from './pages/Reviews';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';

// SEO Landing Pages
import SEOLanding from './pages/SEOLanding';
import { Privacy, Terms, NotFound } from './pages/Legal';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/puppies" element={<Puppies />} />
            <Route path="/supplies" element={<Supplies />} />
            <Route path="/care" element={<Care />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            
            {/* SEO Landing Pages */}
            <Route path="/puppies-in-noida" element={<SEOLanding keyword="Puppies in Noida" />} />
            <Route path="/buy-puppy-noida" element={<SEOLanding keyword="Buy Puppy in Noida" />} />
            <Route path="/dog-shop-noida" element={<SEOLanding keyword="Dog Shop in Noida" />} />
            <Route path="/pet-store-sector-31-noida" element={<SEOLanding keyword="Pet Store Sector 31 Noida" />} />
            <Route path="/golden-retriever-puppy-noida" element={<SEOLanding keyword="Golden Retriever Puppy Noida" breed="Golden Retriever" />} />
            <Route path="/shih-tzu-puppy-noida" element={<SEOLanding keyword="Shih Tzu Puppy Noida" breed="Shih Tzu" />} />
            <Route path="/maltipoo-puppy-noida" element={<SEOLanding keyword="Maltipoo Puppy Noida" breed="Maltipoo" />} />
            <Route path="/husky-puppy-noida" element={<SEOLanding keyword="Husky Puppy Noida" breed="Husky" />} />
            <Route path="/german-shepherd-puppy-noida" element={<SEOLanding keyword="German Shepherd Puppy Noida" breed="German Shepherd" />} />
            <Route path="/labrador-puppy-noida" element={<SEOLanding keyword="Labrador Puppy Noida" breed="Labrador" />} />
            <Route path="/akita-puppy-noida" element={<SEOLanding keyword="Akita Puppy Noida" breed="Akita" />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <ChatBot />
        <LeadPopup />
        <StickyContactBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
